import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const FilterSelect = ({ id, label, value, onChange, options, placeholder = "Any" }) => (
  <div className="flex flex-col gap-2">
    <label htmlFor={id} className="eyebrow">{label}</label>
    <Select value={value || "__any"} onValueChange={(v) => onChange(v === "__any" ? "" : v)}>
      <SelectTrigger
        id={id} data-testid={`${id}-trigger`}
        className="h-12 rounded-none bg-[#121212] border-gold/35 text-ivory hover:border-saffron focus:ring-1 focus:ring-saffron focus:ring-offset-0 text-sm tracking-wide"
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent data-testid={`${id}-content`} className="rounded-none bg-[#121212] border-gold/35 text-ivory max-h-[320px]">
        <SelectItem value="__any" data-testid={`${id}-option-any`} className="rounded-none focus:bg-gold/15 focus:text-saffron text-ivory/70">{placeholder}</SelectItem>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value} data-testid={`${id}-option-${o.value.replace(/[^a-zA-Z0-9]/g, "")}`} className="rounded-none focus:bg-gold/15 focus:text-saffron">
            {o.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
